<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">신고포상제</h1>
      <p class="page-tit">자주 묻는 질문</p>
    </div>
    <!-- 자주 묻는 질문 -->
    <section class="section-accordion__wrap type-faq">
      <article
        v-for="(item, index) in items"
        :key="item.id || index"
        class="section-accordion__item"
      >
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            :aria-expanded="activeIndex === index"
            :aria-controls="`panel-${index}`"
            :id="`accordion-trigger-${index}`"
            @click="toggle(index)"
            :aria-describedby="`panel-${index}-desc`"
          >
            <span class="section-accordion__num" aria-hidden="true"
              >Q{{ index + 1 }}</span
            >
            <span class="section-accordion__title">{{ item.title }}</span>
            <span class="section-accordion__chevron" aria-hidden="true">
              <i class="svg_icon icon_arrow_down"></i>
            </span>
          </button>
        </h3>
        <div
          :id="`panel-${index}`"
          class="section-accordion__panel"
          role="region"
          :aria-labelledby="`accordion-trigger-${index}`"
          v-show="activeIndex === index"
        >
          <div class="section-accordion__content" aria-live="polite">
            <div class="section-accordion__inner">
              <pre :id="`panel-${index}-desc`" class="section-accordion__desc">
                {{ item.contents }}
              </pre>
            </div>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const items = ref([]);
    const activeIndex = ref(null);

    //methods 정의
    const getList = () => {
      showLoading();
      axios
        .post("/core/pu/view/faq/get", {})
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            items.value = res.data.resList;
          } else {
            items.value = [];
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const toggle = (i) => {
      activeIndex.value = activeIndex.value === i ? null : i;
    };
    // life cycle 정의
    onMounted(() => {
      getList();
    });
    // html에서 사용될 데이터 정의
    return {
      items,
      activeIndex,
      toggle,
    };
  },
};
</script>